import { render, staticRenderFns } from "./RectComponent.vue?vue&type=template&id=64842f1d&scoped=true"
import script from "./RectComponent.vue?vue&type=script&lang=ts"
export * from "./RectComponent.vue?vue&type=script&lang=ts"
import style0 from "./RectComponent.vue?vue&type=style&index=0&id=64842f1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64842f1d",
  null
  
)

export default component.exports